import React, { useState, useEffect } from "react";
import styles from "./FrequenciesPage.module.css";

export default function FrequenciesPage() {
  const [data, setData] = useState([]);
  const [openPackages, setOpenPackages] = useState({});
  const [openSatellites, setOpenSatellites] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch("/data/frequencies.json")
      .then((res) => res.json())
      .then((json) => setData(json.packages))
      .catch((err) => console.error("Failed to load frequencies.json", err));
  }, []);

  const togglePackage = (index) => {
    setOpenPackages((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleSatellite = (pkgIdx, satIdx) => {
    const key = `${pkgIdx}-${satIdx}`;
    setOpenSatellites((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const filteredData = data.filter((pkg) =>
    pkg.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Frequencies</h1>

      <div className={styles.searchSection}>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="Search by package name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          aria-label="Search packages"
        />
      </div>

      {filteredData.map((pkg, idx) => (
        <div key={idx} className={styles.package}>
          <div
            className={styles.packageHeader}
            onClick={() => togglePackage(idx)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && togglePackage(idx)}
          >
            <span className={styles.packageName}>{pkg.name}</span>
            <span
              className={`${styles.toggleIcon} ${
                openPackages[idx] ? styles.open : ""
              }`}
            >
              ▼
            </span>
          </div>

          {openPackages[idx] && (
            <div className={styles.packageDetails}>
              {pkg.satellites.map((sat, sidx) => {
                const satKey = `${idx}-${sidx}`;
                return (
                  <div key={sidx} className={styles.satellite}>
                    <div
                      className={styles.satelliteHeader}
                      onClick={() => toggleSatellite(idx, sidx)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) =>
                        e.key === "Enter" && toggleSatellite(idx, sidx)
                      }
                    >
                      {sat.name}
                      <span
                        className={`${styles.toggleIcon} ${
                          openSatellites[satKey] ? styles.open : ""
                        }`}
                      >
                        ▼
                      </span>
                    </div>

                    {openSatellites[satKey] && (
                      <div className={styles.frequencyTableWrapper}>
                        <table className={styles.frequencyTable}>
                          <thead>
                            <tr>
                              <th>التردد</th>
                              <th>الاستقطاب</th>
                              <th>معدل الترميز</th>
                              <th>FEC</th>
                              <th>القنوات</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sat.frequencies.map((freq, fidx) => (
                              <tr key={fidx}>
                                <td>{freq.frequency}</td>
                                <td>{freq.polarization}</td>
                                <td>{freq.symbol_rate}</td>
                                <td>{freq.fec}</td>
                                <td>
                                  <ul className={styles.channelList}>
                                    {freq.channels.map((ch, cidx) => (
                                      <li key={cidx}>{ch}</li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                );
              })}

              {pkg.rights && pkg.rights.length > 0 && (
                <div className={styles.rightsSection}>
                  {pkg.rights.map((right, ridx) => (
                    <img
                      key={ridx}
                      src={right.logo}
                      alt={right.name}
                      className={styles.rightLogo}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
